if (!Object.values) {
    Object.values = function (object) {
        return object && typeof object === 'object' ? Object.keys(object).map(key => object[key]) : [];
    };
}
